import { EntityState, createEntityAdapter } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';

import { setLoadingOn, unsetLoadingOn } from 'ish-core/utils/ngrx-creators';

import { CustomDotCmsPage } from '../../models/page/custom-dot-cms-page.model';
import { generateDotCmsRouterURI } from '../../utils/dot-cms-utils';
import { triggerDotcmsLoading } from '../dotcms-navigation/dotcms-navigation.action';

import { loadDotCmsPage, loadDotCmsPageFail, loadDotCmsPageSuccess, resetDotCmsPageData } from './dotcms-pages.action';

export interface DotCmsPagesState extends EntityState<CustomDotCmsPage> {
  loading?: boolean;
}

export const dotCmsPageEntityAdapter = createEntityAdapter<CustomDotCmsPage>({
  selectId: page => generateDotCmsRouterURI(page.metaInfo.pageURI),
});

const initialState = dotCmsPageEntityAdapter.getInitialState({
  loading: false,
});

export const dotCmsPagesReducer = createReducer(
  initialState,
  setLoadingOn(loadDotCmsPage, triggerDotcmsLoading),
  unsetLoadingOn(loadDotCmsPageSuccess, loadDotCmsPageFail),
  on(loadDotCmsPageSuccess, (state, action) => ({
    ...dotCmsPageEntityAdapter.setOne(action.payload.page, state),
  })),
  on(resetDotCmsPageData, state => ({
    ...state,
    ...dotCmsPageEntityAdapter.removeAll(state),
  }))
);
